import React from 'react';

import ValidationErrorsTable, {SpreadsheetType} from 'bulk-import/panes/ValidationErrorsTable';
import {SpreadsheetValidationErrorInfo} from 'bulk-import/SpreadsheetBulkImportConstants';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';
import Modal, {ModalButton} from 'ui-library/modals/Modal';
import {Optional} from 'util/Types';

export interface StructuredTableBulkAdapterErrorsModalProps {
  title?: string;
  tagSchemaId: string;
  errorData: SpreadsheetValidationErrorInfo;
  onRequestClose: () => void;
  extraButtons?: Optional<Array<ModalButton>>;
  extraErrorExplanation?: string | React.ReactNode | null;
}

export default function StructuredTableBulkAdapterErrorsModal(
  props: StructuredTableBulkAdapterErrorsModalProps
): JSX.Element {
  const buttons: Array<ModalButton> = [
    {
      text: 'Cancel',
      cancel: true,
    },
  ];
  if (props.extraButtons) {
    buttons.push(...props.extraButtons);
  }
  const optionalWarningBanner = props.extraErrorExplanation ? (
    <InlineBanner bannerType={InlineBannerType.WARNING} text={props.extraErrorExplanation} />
  ) : null;

  return (
    <Modal
      enableRedesign={true}
      title={props.title || 'Errors'}
      onRequestClose={props.onRequestClose}
      buttons={buttons}
    >
      <ValidationErrorsTable
        spreadsheetType={SpreadsheetType.STRUCTURED_TABLE}
        errorData={props.errorData}
        resolvableErrorStatuses={{}}
        selectedTagSchemaId={props.tagSchemaId}
      />
      {optionalWarningBanner}
    </Modal>
  );
}
